import _get from "lodash/get";
import React from 'react';
import { injectIntl } from 'react-intl';
import { useIdentityContext } from 'react-netlify-identity/dist/index';
import { buttonSkinData, buttonBtnTypeData } from '@luigiclaudio/ga-baseline-ui/button';
import { FormAccount } from '@luigiclaudio/ga-baseline-ui/auth';
import { useLoading } from '@luigiclaudio/ga-baseline-ui/helpers';
import useAuthFeedback from '../utils/useAuthFeedback';

var AuthAccount = function AuthAccount(_ref) {
  var intl = _ref.intl,
      buttonSkin = _ref.buttonSkin,
      buttonBtnType = _ref.buttonBtnType,
      showHeading = _ref.showHeading,
      updatedUserCallback = _ref.updatedUserCallback,
      disabled = _ref.disabled;

  var _useIdentityContext = useIdentityContext(),
      user = _useIdentityContext.user,
      updateUser = _useIdentityContext.updateUser,
      isConfirmedUser = _useIdentityContext.isConfirmedUser;

  var _useLoading = useLoading(),
      isLoading = _useLoading[0],
      load = _useLoading[1];

  var currentEmail = _get(user, 'email', '');

  var currentUsername = _get(user, 'user_metadata.full_name', '');

  var initialValues = {
    emailAddress: currentEmail,
    username: currentUsername,
    newPassword: ''
  };

  var _useAuthFeedback = useAuthFeedback(),
      handleFeedbackMessage = _useAuthFeedback.handleFeedbackMessage,
      feedbackMessage = _useAuthFeedback.feedbackMessage,
      hasForm = _useAuthFeedback.hasForm,
      hasFeedback = _useAuthFeedback.hasFeedback;

  var handleUpdateUser = function handleUpdateUser(values) {
    var username = values.username,
        newPassword = values.newPassword;

    if (currentUsername !== username || newPassword !== '') {
      load(updateUser({
        password: newPassword,
        data: {
          full_name: username
        }
      })).then(function (currentUser) {
        handleFeedbackMessage({
          type: 'success',
          message: intl.formatMessage({
            id: 'auth.account.update.success.message'
          }),
          feedbackCallback: function feedbackCallback() {
            return updatedUserCallback({
              currentUsername: currentUser.user_metadata.full_name
            });
          }
        });
        return currentUser;
      }).catch(function (err) {
        handleFeedbackMessage({
          type: 'danger',
          message: intl.formatMessage({
            id: 'auth.account.update.error.message'
          })
        });
        throw err;
      });
    } else {
      handleFeedbackMessage({
        type: 'info',
        message: intl.formatMessage({
          id: 'auth.account.noChanges.message'
        })
      });
    }
  };

  return /*#__PURE__*/React.createElement(FormAccount, {
    inProp: hasForm,
    inPropFeedback: hasFeedback,
    accountInitialValues: initialValues,
    onSubmitUpdateUser: function onSubmitUpdateUser(values) {
      return handleUpdateUser(values);
    },
    isLoading: isLoading,
    feedbackType: feedbackMessage.type,
    feedbackMessage: feedbackMessage.message,
    isAccountDisabled: !isConfirmedUser,
    accountDisabledMessage: intl.formatMessage({
      id: 'auth.account.notConfirmed.message'
    }),
    buttonSkin: buttonSkin,
    buttonBtnType: buttonBtnType,
    showHeading: showHeading,
    disabled: disabled
  });
};

AuthAccount.defaultProps = {
  buttonSkin: 'primary',
  buttonBtnType: 'default',
  showHeading: true,
  updatedUserCallback: function updatedUserCallback() {},
  disabled: false
};
export default injectIntl(AuthAccount);